import {post} from '../shoptools/fetch';
import {updateCart} from '../shoptools/index';
import $ from 'jquery'; // TODO purge
import {setVal} from '../util/jquery.formstyles';

class CartAddForm {
  constructor (el) {
    this.el = el
    this.priceEl = this.el.querySelector('.price .value');

    this.pkData = JSON.parse(this.el.dataset.pkData);
    this.pkEl = this.el.querySelector('input[name="pk"]');

    this.nameOptionsEl = this.el.querySelector('.name-options');
    this.colorOptionsEl = this.el.querySelector('.color-options')
    this.shapeOptionsEl = this.el.querySelector('.shape-options');
    this.sizeOptionsEl = this.el.querySelector('.size-options');
    this.bindingOptionsEl = this.el.querySelector('.binding-options');

    this.nameOptionsSelect = this.nameOptionsEl ? this.nameOptionsEl.querySelector('select') : null;
    this.colorOptionsInputs = this.colorOptionsEl ? this.colorOptionsEl.querySelectorAll('input') : null
    this.shapeOptionsSelect = this.shapeOptionsEl ? this.shapeOptionsEl.querySelector('select') : null;
    this.sizeOptionsSelect = this.sizeOptionsEl ? this.sizeOptionsEl.querySelector('select') : null;
    this.bindingOptionsSelect = this.bindingOptionsEl ? this.bindingOptionsEl.querySelector('select') : null;

    this.nameCurrent = this.nameOptionsEl ? this.pkEl.dataset.defaultNameOption : null;
    this.colorCurrent = this.colorOptionsEl ? this.pkEl.dataset.defaultColorOption : null
    this.shapeCurrent = this.shapeOptionsEl ? this.pkEl.dataset.defaultShapeOption : null;
    this.sizeCurrent = this.sizeOptionsEl ? this.pkEl.dataset.defaultSizeOption : null;
    this.bindingCurrent = this.bindingOptionsEl ? this.pkEl.dataset.defaultBindingOption : null;

    this.optionsCount = 0;
    this.primarySelect = []; // can never be invalid

    if (this.shapeOptionsSelect) {
      this.optionsCount += 1;
      this.primarySelect.push(this.shapeOptionsSelect);
      const select = this.shapeOptionsSelect;
      select.addEventListener('change', () => {
        this.shapeCurrent = select.value;
        this.defineCurrentPK('shape', 'shapeCurrent');
      });
    }
    if (this.nameOptionsSelect) {
      this.optionsCount += 1;
      this.primarySelect.push(this.nameOptionsSelect);
      const select = this.nameOptionsSelect;
      select.addEventListener('change', () => {
        this.nameCurrent = select.value;
        this.defineCurrentPK('name', 'nameCurrent');
      });
    }
    if (this.colorOptionsInputs) {
      this.optionsCount += 1;
      this.colorOptionsInputs.forEach(input => {
        this.primarySelect.push(input);
        input.addEventListener('change', () => {
          this.colorCurrent = input.value;
          this.defineCurrentPK('color', 'colorCurrent');
        });
      });
    }
    if (this.sizeOptionsSelect) {
      this.optionsCount += 1;
      const select = this.sizeOptionsSelect;
      select.addEventListener('change', () => {
        this.sizeCurrent = select.value;
        this.defineCurrentPK('size', 'sizeCurrent');
      });
    }
    if (this.bindingOptionsSelect) {
      this.optionsCount += 1;
      const select = this.bindingOptionsSelect;
      select.addEventListener('change', () => {
        this.bindingCurrent = select.value;
        this.defineCurrentPK('binding', 'bindingCurrent');
      });
    }

    // bind keyup listener
    this.el.addEventListener('submit', (e) => {
      e.preventDefault();
      this.submit();
    });

    this.defineCurrentPK();
  }
  submit () {
    if (this.pkEl.value === '') {
      this.el.classList.add('please-select');
      setTimeout(() => {
        this.el.classList.remove('please-select');
      }, 2500);
      return false;
    }

    const url = this.el.getAttribute('action');
    const data = $(this.el).serialize();

    post(url, data).then((response) => {
      return response.json();
    }).then((data) => {
      if (data.success) {
        this.el.classList.add('added', 'show-checkout');
        this.el.classList.remove('error');
        // document.querySelector('.cart-link').classList.add('product-added')

        if (data.cart) {
          updateCart(Object.assign(data.cart, {'html_snippet': data.html_snippet}));
        }

        setTimeout(() => {
          this.el.classList.remove('added');
        }, 5000);

        // globalUpdate(data);
      } else {
        this.el.querySelector('.errors').innerHTML = data.errors.join('<br>');
        this.el.classList.add('error');
        this.el.classList.remove('added');
      }
      if (this.layoutCallback) this.layoutCallback();
    });
  }

  defineCurrentPK (option, currentOption) {
    let match = this.pkData.find(obj => {
      return obj.name === this.nameCurrent &&
             obj.color === this.colorCurrent &&
             obj.shape === this.shapeCurrent &&
             obj.size === this.sizeCurrent &&
             obj.binding === this.bindingCurrent;
    });

    // console.log(match);

    if (!match) {
      // fallback to the first matching the selected option,
      // in some cases we need to preserve heirarchy
      match = this.pkData.find(obj => {
        switch (option) {
          case 'name':
            return obj.color === this.colorCurrent &&
                   obj[option] === this[currentOption];
          case 'shape':
            return obj.name === this.nameCurrent &&
                   obj.color === this.colorCurrent &&
                   obj[option] === this[currentOption];
          default:
            return undefined;
        }
      });
      if (!match) {
        match = this.pkData.find(obj => {
          return obj[option] === this[currentOption];
        });
      }

      switch (option) {
        case 'name':
          this.colorCurrent = match.color;
          this.shapeCurrent = match.shape;
          this.sizeCurrent = match.size;
          this.bindingCurrent = match.binding;
          break;
        case 'color':
          this.nameCurrent = match.name;
          this.shapeCurrent = match.shape;
          this.sizeCurrent = match.size;
          this.bindingCurrent = match.binding;
          break;
        case 'shape':
          this.nameCurrent = match.name;
          this.colorCurrent = match.color;
          this.sizeCurrent = match.size;
          this.bindingCurrent = match.binding;
          break;
        case 'size':
          this.nameCurrent = match.name;
          this.colorCurrent = match.color;
          this.shapeCurrent = match.shape;
          this.bindingCurrent = match.binding;
          break;
        case 'binding':
          this.nameCurrent = match.name;
          this.colorCurrent = match.color;
          this.shapeCurrent = match.shape;
          this.sizeCurrent = match.size;
          break;
        default:
          this.colorCurrent = match.color;
          this.colorCurrent = match.color;
          this.shapeCurrent = match.shape;
          this.sizeCurrent = match.size;
          this.bindingCurrent = match.binding;
          break;
      }
    }
    // console.log(match)
    this.dataCurrent = match;

    this.updateNames();
    this.updateColors();
    this.updateShapes();
    this.updateSizes();
    this.updateBindings();
    this.updatePrice();
    this.updatePK();
    this.updateImage();
  }

  updatePrice () {
    this.priceEl.innerHTML = this.dataCurrent.price;
    this.el.classList[this.dataCurrent.available === 'sold-out' ? 'add' : 'remove']('sold-out');
  }
  updatePK () {
    this.pkEl.value = this.dataCurrent.pk;
  }
  updateImage () {
    if (window.sampleGallery) {
      try {
        window.sampleGallery.getCellElements().forEach((el, index) => {
          if (el.dataset.sampleId === this.dataCurrent.sample) {
            window.sampleGallery.select(index);
          }
        });
      } catch (e) {
        console.log(e)
      }
    }
  }
  updateNames () {
    if (!this.nameOptionsSelect) return false;

    const select = this.nameOptionsSelect;
    [...select.querySelectorAll('option')].forEach((option) => {
      const match = this.pkData.find(obj => {
        // look for all items that match the current variant
        return obj.name === option.value &&
               obj.color === this.colorCurrent &&
               obj.shape === this.shapeCurrent &&
               obj.size === this.sizeCurrent &&
               obj.binding === this.bindingCurrent;
      });
      option.disabled = !match && this.optionsCount !== 1 && this.primarySelect.indexOf(select) < 0;
    });
    this.nameOptionsEl.classList[this.nameCurrent || this.optionsCount === 1 ? 'add' : 'remove']('valid-option');
    select.value = this.nameCurrent;
    setVal($(select));
    // select.querySelector(`option[value='${this.nameCurrent}']`).selected = true
  }
  updateColors () {
    if (!this.colorOptionsInputs) return false

    ;[...this.colorOptionsInputs].forEach((input) => {
      const match = this.pkData.find(obj => {
        // look for all items that match the current variant
        return obj.name === this.nameCurrent &&
               obj.color === input.value &&
               obj.shape === this.shapeCurrent &&
               obj.size === this.sizeCurrent &&
               obj.binding === this.bindingCurrent;
      });
      // input.parentElement.classList[match || this.optionsCount === 1 ? 'add' : 'remove']('valid-option');
      input.parentElement.classList['add']('valid-option');
      // input.disabled = !match && this.optionsCount !== 1;
      input.parentElement.classList[input.value === this.colorCurrent ? 'add' : 'remove']('checked');
      input.checked = input.value === this.colorCurrent;
    });
  }
  updateShapes () {
    if (!this.shapeOptionsSelect) return false;

    const select = this.shapeOptionsSelect
    ;[...select.querySelectorAll('option')].forEach((option) => {
      const match = this.pkData.find(obj => {
        // look for all items that match the current variant
        return obj.name === this.nameCurrent &&
               obj.color === this.colorCurrent &&
               obj.shape === option.value &&
               obj.size === this.sizeCurrent &&
               obj.binding === this.bindingCurrent;
      });
      option.disabled = !match && this.optionsCount !== 1 && this.primarySelect.indexOf(select) < 0;
    });
    this.shapeOptionsEl.classList[this.shapeCurrent || this.optionsCount === 1 ? 'add' : 'remove']('valid-option');
    select.value = this.shapeCurrent;
    setVal($(select));
    // select.querySelector(`option[value='${this.shapeCurrent}']`).selected = true
  }
  updateSizes () {
    if (!this.sizeOptionsSelect) return false;

    const select = this.sizeOptionsSelect
    ;[...select.querySelectorAll('option')].forEach((option) => {
      const match = this.pkData.find(obj => {
        // look for all items that match the current variant
        return obj.name === this.nameCurrent &&
               obj.color === this.colorCurrent &&
               obj.shape === this.shapeCurrent &&
               obj.size === option.value &&
               obj.binding === this.bindingCurrent;
      });
      option.disabled = !match && this.optionsCount !== 1 && this.primarySelect.indexOf(select) < 0;
    });
    this.sizeOptionsEl.classList[this.sizeCurrent || this.optionsCount === 1 ? 'add' : 'remove']('valid-option');
    select.value = this.sizeCurrent;
    setVal($(select));
    // select.querySelector(`option[value='${this.sizeCurrent}']`).selected = true
  }
  updateBindings () {
    if (!this.bindingOptionsSelect) return false;

    const select = this.bindingOptionsSelect
    ;[...select.querySelectorAll('option')].forEach((option) => {
      const match = this.pkData.find(obj => {
        // look for all items that match the current variant
        return obj.name === this.nameCurrent &&
               obj.color === this.colorCurrent &&
               obj.shape === this.shapeCurrent &&
               obj.size === this.sizeCurrent &&
               obj.binding === option.value;
      });
      option.disabled = !match && this.optionsCount !== 1 && this.primarySelect.indexOf(select) < 0;
    });
    this.bindingOptionsEl.classList[this.bindingCurrent || this.optionsCount === 1 ? 'add' : 'remove']('valid-option');
    select.value = this.bindingCurrent;
    setVal($(select));
    // select.querySelector(`option[value='${this.bindingCurrent}']`).selected = true
  }
}

export { CartAddForm };



// WEBPACK FOOTER //
// ./assets/j/shoptools/cart.js